export function generateFilteredVideos(
    videos = [],
    selectedConferenceTags = [],
    selectedCategoryTags = []
) {
    if (!selectedConferenceTags.length) {
        return videos;
    }

    const videosFilteredByConference = videos.filter((video) => {
        return selectedConferenceTags.some((selectedConferenceTag) => {
            return video.tags.some((videoTag) => {
                return videoTag === selectedConferenceTag.id;
            });
        });
    });
    const videosFilteredByCategory = videosFilteredByConference.filter(
        (video) => {
            return selectedCategoryTags.some((selectedCategoryTag) => {
                return video.tags.some((videoTag) => {
                    return videoTag === selectedCategoryTag.id;
                });
            });
        }
    );
    return videosFilteredByCategory;
}
